import React, { lazy } from 'react';
const images = ['https://cdn.magicpatterns.com/uploads/n7AZEP33ozaAwjadobxY6M/Captura_de_pantalla_2026-06-01_145009.png', 'https://cdn.magicpatterns.com/uploads/m3VAZHxTjdEUzeiGYjEJ1G/Captura_de_pantalla_2026-06-01_145028.png', 'https://cdn.magicpatterns.com/uploads/g5ef6j7AchwjDwB5PwzTAu/Captura_de_pantalla_2026-06-01_145108.png', 'https://cdn.magicpatterns.com/uploads/4WL3YMgKPiym1Sk9yaDiFJ/Captura_de_pantalla_2026-06-01_145504.png', 'https://cdn.magicpatterns.com/uploads/ijReweci74qXhXiGEzX4r6/Captura_de_pantalla_2026-06-01_145541.png'];
export function ImageMarquee() {
  // Duplicate the array for a seamless infinite loop
  const loop = [...images, ...images];
  return <section className="py-6 bg-brand-cream overflow-hidden" data-id="element-173">
      <div className="text-center mb-4 px-4" data-id="element-174">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-brand-dark" data-id="element-175">
          ✨ Inspiración de lo que vas a poder crear
        </h2>
      </div>

      <div className="relative w-full overflow-hidden" style={{
      maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)'
    }} data-id="element-176">
        <div className="flex gap-4 animate-marquee w-max" data-id="element-177">
          {loop.map((src, i) => <div key={i} className="w-40 h-40 md:w-52 md:h-52 rounded-2xl overflow-hidden shadow-soft border border-white shrink-0 bg-white" data-id="element-178">
              <img src={src} alt={`Punch Needle diseño ${i % images.length + 1}`} className="w-full h-full object-cover" loading="lazy" data-id="element-179" />
            </div>)}
        </div>
      </div>
    </section>;
}